import { ssoClient } from '@better-auth/sso/client';
import { organizationClient } from 'better-auth/client/plugins';
import { createAuthClient } from 'better-auth/react';
import { API_HOSTNAME, BETTER_AUTH_BASE_URL } from '@/config';

const baseURL = BETTER_AUTH_BASE_URL || API_HOSTNAME || 'http://localhost:3000';
const fullBaseURL = `${baseURL}/v1/better-auth`;

export const authClient = createAuthClient({
  baseURL: fullBaseURL,
  plugins: [organizationClient(), ssoClient()],
  fetchOptions: {
    // Cookie-based session auth (same-origin with the API). The session cookie is httpOnly, so the
    // SSO browser-redirect can't surface a bearer token to localStorage — and a Bearer `auth` block
    // with an empty token makes useSession() resolve "no session" WITHOUT ever calling the server,
    // which bounced SSO users straight to /auth/sign-in. Rely on the cookie instead; `onSuccess`
    // still captures a bearer token for the Novu API client when one is issued (email/password).
    credentials: 'include',
    onSuccess: (ctx) => {
      const authToken = ctx.response.headers.get('set-auth-token');
      if (authToken) {
        localStorage.setItem('better-auth-session-token', authToken);
      }
    },
  },
});

export type AuthClient = typeof authClient;
